import { render, staticRenderFns } from "./shetuzidian.vue?vue&type=template&id=f36c65f4&"
import script from "./shetuzidian.vue?vue&type=script&lang=ts&"
export * from "./shetuzidian.vue?vue&type=script&lang=ts&"
import style0 from "./shetuzidian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports